import React,{ useContext, useState} from "react";

const ThemeContext = React.createContext();
const ThemeUpdateContext = React.createContext();

export function useBuildTheme() {
    return useContext(ThemeContext);
}

export function useBuildUpdate() {
    return useContext(ThemeUpdateContext);
}


export function BuildThemeProvider({children}){
    
    const [currentBuild, setCurrentBuild] = useState(1);

    function updateThemeColor(build) {
        const color = BuildStyles[build].mainNav;
        document.querySelector('meta[name="theme-color"]').setAttribute('content', color);
        document.body.style.backgroundColor = color;
    }

    function toggleBuildTheme(){
        let nextBuild = currentBuild + 1;

        if (nextBuild === 3){
            nextBuild = 0;
        }
        updateThemeColor(nextBuild);
        setCurrentBuild(nextBuild);
    }

    return (
    <ThemeContext.Provider value={currentBuild}>
        <ThemeUpdateContext.Provider value={toggleBuildTheme}>
            {children}
        </ThemeUpdateContext.Provider>
    </ThemeContext.Provider>)

}



export const BuildStyles = {
    
    [0] : { // eslint-disable-line
        main: '#1B41A8DA',
        mainNav: '#1B41A8',
        accent: '#CC5938',
         btn: '#FCFDFA',
         btnText: '#CC5938'
    },
    [1] : { // eslint-disable-line
        main: '#371C6EDA',
        mainNav: '#371C6E',
        accent: '#FEAC4A',
        btn: '#BCD167',
         btnText: '#221A2B'
    },
    [2] : { // eslint-disable-line
        main: '#99221BDA',
        mainNav: '#99221B',
        accent: '#96BA35',
        btn: '#FEAC4A',
        btnText: '#FCFDFA'
    },

    maxWidth : '1400px',
    transitionStyleTop: '.25s ease-in',
    transitionStyleMid: '.55s ease-in',
    transitionStyleBottom: '.8s cubic-bezier(1,.02,.25,.5)',
    letterSpacingDG: '.1rem',
    breakpoint: {
        xs: '430px',
        sm: '576px',
        md: '767px',
        lg: '1000px',
        xl: '1500px',
    }

}